import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import moment from 'moment';
import DateInputPicker2 from 'modules/common/components/DateInputPicker2';
import * as c from '../constant';
import * as actions from '../actions';

function RecalCalculateSOADate({
  id,
  recalculateSOA,
  getItem,
  recalculatingSOA,
}) {
  const [formData, setFormData] = useState({
    billing_date: `${moment(new Date()).format('MM/DD/YYYY')}`,
  });
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = Acl(permissions, ['OVERRIDE BPLS BILLING DATE'])
      ? formData
      : '';

    recalculateSOA(id, args, () => {
      setModal({ isOpen: false });

      getItem(id);
    });
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const year = new Date().getFullYear();
  const minimumDate = `01/01/${year}`;

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          {Acl(permissions, ['OVERRIDE BPLS BILLING DATE']) ? (
            ''
          ) : (
            <div className="col-12 form-group">
              Are you sure, do you want recalculate SOA for this application?
            </div>
          )}
          {Acl(permissions, ['OVERRIDE BPLS BILLING DATE']) && (
            <div className="col-12 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Date
              </label>
              <DateInputPicker2
                required
                className="full-input"
                onChange={handleOnChangeDate('billing_date')}
                value={_.get(formData, 'billing_date') || ''}
                showYearDropdown={false}
                minDate={new Date(minimumDate)}
                maxDate={new Date()}
              />
            </div>
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            disabled={recalculatingSOA}
          >
            <span className="font-weight-bold">
              {/* eslint-disable */}
              {recalculatingSOA ? (
                <i className="fa fa-spin fa-spinner" />
              ) : Acl(permissions, ['OVERRIDE BPLS BILLING DATE']) ? (
                'Submit'
              ) : (
                'Confirm'
              )}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

RecalCalculateSOADate.propTypes = {
  id: PropTypes.string.isRequired,
  recalculateSOA: PropTypes.instanceOf(Function).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  recalculatingSOA: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  recalculatingSOA: api.loading.indexOf(c.RECALCULATE_SOA) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RecalCalculateSOADate);
